import React from 'react';

import EmojiAsset01 from "../../../assets/images/icons/emoji_happy.png";
import EmojiAsset02 from "../../../assets/images/icons/emoji_love.png";
import EmojiAsset03 from "../../../assets/images/icons/emoji_lol.png";
import EmojiAsset04 from "../../../assets/images/icons/emoji_sad.png";
import Zigzag from "../../UI/Common/Shapes/Zigzag";
import DoubleHalfCircle from './../../UI/Common/Shapes/DoubleHalfCircle';


/**
 * Container used, in article's details page, to display the cover
 */
const CoverBlock = (props) => {
    return(
        <div className="article-cover" style={props.coverBgStyle}>
            <div className="highlight">
                <h4>{props.thematicName}</h4>
                <h3>{props.title}</h3>
                <span className="author"><span className="by">Par&nbsp;</span>{props.author}</span>
                <span className={`likes ${(parseInt(props.likes, 10)===0)?"hide":''}`}>
                    <div className="reactions-emo">
                        <img src={EmojiAsset01} alt="Content" ></img>
                        <img src={EmojiAsset02} alt="Amoureux" ></img>
                        <img src={EmojiAsset03} alt="Marrant" ></img>
                        <img src={EmojiAsset04} alt="Triste"></img>
                    </div>
                    <div className="total">
                        {props.likes}
                    </div>
                </span>
                <div className="yellow-zigzag">
                    <Zigzag color="#ffde39" translateXaxis="10"/>
                </div>
                <div className="dual-half-circle">
                    <DoubleHalfCircle color1='#473080' color2='#00c2a9' rotateAngle="-110"/>
                </div>
            </div>
        </div>
    );
}

export default CoverBlock;



// WEBPACK FOOTER //
// ./src/containers/Article/Details/CoverBlock.js